<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import getInitials from '@/helpers/get-initials'
import api from '@/helpers/api'
import simplebar from 'simplebar-vue'

export default {
  name: 'sales.customers.settings',
  page: {
    title: 'Sales - Customer',
    meta: [{ name: 'description', settings_content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  props: {
    customer_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    customer: {
      billing_address: {}
    }
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    customer_id: 'onInit'
  },

  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.customers.fetch({
        id: this.customer_id
      })
      this.customer = {
        ...item,
        initials: getInitials(item.legal_name),
        billing_email: item.billing_email.join(',')
      }
      this.isLoading = false
    },
    async onRemoveHandler (tryDelete = false) {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Are you sure you want to archive this customer?',
        {
          title: 'Confirm Archive Customer',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelVariant: 'danger',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      if (ok) {
        try {
          this.isLoading = true
          await api.customers.update({
            is_archived: true,
            id: this.customer_id
          })

          if (tryDelete) {
            try {
              await api.customers.delete({
                id: this.customer_id
              })
            } catch (del_err) {
              console.error(del_err)
            }
          }

          this.isLoading = false
          this.$router.push({ name: 'sales.customers' })
        } catch (error) {
          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  computed: {
    title () {
      return 'Settings'
    },
    breadcrumbs () {
      return [
        {
          text: 'Sales',
          to: { name: 'sales' }
        },
        {
          text: 'Customers',
          to: { name: 'sales.customers' }
        },
        {
          text: this.customer.legal_name
            ? `${this.customer.legal_name}`
            : 'loading',
          to: { name: 'sales.customers.view' }
        },
        {
          text: 'Settings',
          active: true
        }
      ]
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :items="breadcrumbs">
      <template v-slot:title>
        <div class="d-flex flex-column">
          <div>
            <h4 class="mb-0">
              {{ customer.legal_name }}
            </h4>
          </div>
          <p class="mb-0">Settings</p>
        </div>
      </template>
    </PageHeader>

    <b-row>
      <b-col cols="12">
        <b-card no-body class="email-leftbar p-2">
          <b-nav vertical class="side-nav">
            <b-nav-item
              :to="{ name: 'sales.customers.view' }"
              exact
              class="py-2"
            >
              <i class="bx bx-chevron-left mr-1"></i>Back
            </b-nav-item>

            <b-nav-item :to="{ name: 'sales.customers.settings.info' }" exact>
              <i class="bx bx-info-circle mr-1"></i>Info
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'sales.customers.settings.billing' }"
              exact
            >
              <i class="bx bx-dollar-circle mr-1"></i>Billing Settings
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'sales.customers.settings.addresses' }"
              exact
            >
              <i class="bx bx-map mr-1"></i>Addresses
            </b-nav-item>
            <b-nav-item :to="{ name: 'sales.customers.settings.users' }" exact>
              <i class="bx bx-user mr-1"></i>Users
            </b-nav-item>
            <b-nav-item>
              <b-btn
                variant="link"
                class="text-danger p-0"
                v-on:click="onRemoveHandler"
              >
                <i class="bx bx-archive mr-1"></i>Archive
              </b-btn>
            </b-nav-item>
          </b-nav>
        </b-card>

        <div class="email-rightbar">
          <router-view />
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>
